import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SpinnerSize from 'src/enums/spinnerSize';
import Spinner from 'src/globalComponents/spinner';
import { useApi } from 'src/hooks/useApi.js';

const SignInPerson: React.FC = () => {
	const api = useApi();
	const navigate = useNavigate();
	const { processId, signerId } = useParams();

	const iframeRef = useRef<HTMLIFrameElement>(null);
	const [signUrl, setSignUrl] = useState(null);

	useEffect(() => {
		const handleMessage = (message: MessageEvent) => {
			if (!message.origin.includes('docubee.app')) {
				return;
			}

			const { details, event } = JSON.parse(message.data);

			if (event == 'SIGNING_STATUS') {
				if (details.status == 'complete') {
					navigate(`/signerCompleted/${processId}/${signerId}`);
				}
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	useEffect(() => {
		if (processId && signerId) {
			(async () => {
				const url = await api.esign.getSignInPersonUrl(processId, signerId);

				setSignUrl(url);
			})();
		}
	}, [processId, signerId]);

	return signUrl ? (
		<iframe
			ref={iframeRef}
			src={signUrl}
			width="100%"
			height="1080"
			title="Document Preview"
			style={{ border: 'none' }}
		/>
	) : (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Spinner size={SpinnerSize.LARGE} />
		</Box>
	);
};

export default SignInPerson;
